import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faFacebook, faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import {
    faAngleDown,
    faArrowRightLong,
    faArrowLeftLong,
    faGlobe,
    faMinus,
    faPlus,
    faTimes,
} from "@fortawesome/pro-regular-svg-icons";
import { faChevronCircleRight } from "@fortawesome/pro-solid-svg-icons";
import { faFactsheets } from "./icons/factsheets";

library.add(
    faGlobe,
    faFacebook,
    faInstagram,
    faLinkedin,
    faAngleDown,
    faChevronCircleRight,
    faMinus,
    faPlus,
    faTimes,
    faArrowRightLong,
    faArrowLeftLong,
);

library.add(faFactsheets);

dom.watch();
